// extracted by mini-css-extract-plugin
export default {"banner":"EnvBanner_banner__hXDBl","badge":"EnvBanner_badge__mvypg","note":"EnvBanner_note__yBFp8","close":"EnvBanner_close__OXKOr","pill":"EnvBanner_pill__2OHO9"};